module.exports = __webpack_public_path__ + "static/img/4bg_12.77ffc00.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_12.png
// module id = 706
// module chunks = 1